var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 313.1 88.9",
    style: {
      enableBackground: "new 0 0 313.1 88.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000116230278463779890210000000381263754548669072_);}\n\t.st2{fill:url(#SVGID_00000050646824370490846380000001144021328400403626_);}\n\t.st3{fill:url(#SVGID_00000053511095742505479230000003893818195476971407_);}\n\t.st4{fill:url(#SVGID_00000009564713801839324080000012492457990381721522_);}\n\t.st5{fill:url(#SVGID_00000091706383181024794920000004092585193528509081_);}\n\t.st6{fill:url(#SVGID_00000138547739645131716800000013399762657498746771_);}\n\t.st7{fill:url(#SVGID_00000150820088424530180120000006076785376071528583_);}\n\t.st8{fill:url(#SVGID_00000085957968555580353970000005831774729385776545_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -1.1373,
    cy: -77.3867,
    r: 303.7689,
    gradientTransform: "matrix(1 0 0 -1 0 90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDDE92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDB830"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224,78.1h-17.2l29.1-30.6l0,0l15.8-16.2c0.5-0.6,1.1-1.2,1.6-1.7c5.1-4.7,12.1-6.4,18.8-4.7 c10.8,2.8,17.2,13.9,14.4,24.7l8.6,8.4c2-4.2,3.1-8.9,3.1-13.6l0,0c0-1,0-1.9-0.1-2.9c-1.6-17.2-16.8-29.8-33.9-28.3 c-8.5,0.8-15.9,4.9-21,11l-12.3,12.4l-23.5-25.2h17L235,22.9l7.8-8L229,0h-47.5l41.6,44.4l-41.6,44.4H229L242.7,74l-7.7-7.5 L224,78.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000009591383858756564830000001741046855771219868_",
    cx: 174.5555,
    cy: 53.3323,
    r: 137.0302,
    gradientTransform: "matrix(1 0 0 -1 0 90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDDE92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDB830"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009591383858756564830000001741046855771219868_)"
    },
    d: "M295.2,19.4L295.2,19.4L313.1,0h-47.4 l-6.6,7.2C259.1,7.2,281.8,2.9,295.2,19.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000171721095026145492230000010301164816860797087_",
    cx: 167.603,
    cy: -49.2946,
    r: 151.1518,
    gradientTransform: "matrix(1 0 0 -1 0 90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDDE92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDB830"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171721095026145492230000010301164816860797087_)"
    },
    d: "M277.9,37.8c0,0-2.2-4.4-9.1-6l-12.4,12.9 l17.8,18.7c0,0,0,0-0.1,0l8,8.4c0,0,0,0,0.1,0l4.6,4.9c0,0-8.6,8.4-27.2,5.4l6.2,6.8h47.4l-41.3-44.4L277.9,37.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000090987459468754951370000006985024938874773695_",
    cx: 186.9467,
    cy: -6.0817,
    r: 88.2306,
    gradientTransform: "matrix(1 0 0 -1 0 90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDDE92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDB830"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090987459468754951370000006985024938874773695_)"
    },
    d: "M274.5,74.7l-9.2-10.2 c-7.4-0.6-13.9-5.2-16.8-12l-8.1,8.2c5.6,9.3,15.7,15,26.6,15C269.5,75.7,272,75.4,274.5,74.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096035317301579412270000014257357815642705058_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.7,
    y1: 16.7647,
    x2: 23.7,
    y2: 66.7889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#10284B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E5FAD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096035317301579412270000014257357815642705058_)"
    },
    d: "M45.3,21.2h-0.2c-1.6,0-2.2,0.6-2.3,1.2 l-1.1,2.7c-0.8,1.7-1.8,4.1-3.2,7.2s-2.7,6-3.9,8.7c-0.6,1.3-1.1,2.3-1.4,3L21.5,21.5H0l24.1,46.6l0.1,0.2c0.3,0.4,0.8,0.7,1.4,0.7 c0.1,0,0.2,0,0.3,0c0.7,0,1.3-0.4,1.5-1l19-41.7l0.1-0.2c0.2-0.3,0.3-0.6,0.5-0.9c0.1-0.3,0.2-0.7,0.3-1c0.2-0.6,0.1-1.3-0.3-1.9 C46.6,21.7,46,21.3,45.3,21.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012461188615547576570000009406224674542490812_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.15,
    y1: 16.7647,
    x2: 58.15,
    y2: 66.7889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#10284B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E5FAD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 21.5,
    style: {
      fill: "url(#SVGID_00000012461188615547576570000009406224674542490812_)"
    },
    width: 18.7,
    height: 46.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118396274740803666820000005509443416886162864_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.05,
    y1: 16.7647,
    x2: 91.05,
    y2: 66.7889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#10284B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E5FAD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118396274740803666820000005509443416886162864_)"
    },
    d: "M110.2,26.6c0-1.1-0.1-2.1-0.2-3.2 c-0.2-2.2-1.5-2.4-2-2.4s-1.8,0.3-2.1,2.5c-0.1,1.1-0.2,2.3-0.2,3.4v15c-2.6-1.8-5.9-4.1-10.1-7c-5.1-3.5-9.6-6.7-13.7-9.5 c-6.1-4.2-6.4-4.3-6.6-4.4c-0.4-0.2-0.8-0.2-1.2-0.2c-1.1-0.1-2,0.6-2.2,1.7c0,0.1,0,0.2,0,0.3v43.1c0.1,0.5,0.2,0.9,0.4,1.4 c0.3,0.8,1.2,1.2,2,1.2c1.5,0,2-0.8,2.1-1.2c0.1-0.5,0.2-0.9,0.2-1.4V47.2c2.4,1.7,5.1,3.5,8,5.6c3.6,2.5,8.3,5.7,14.1,9.6 c8.9,6,8.9,6,9.3,6c0.7,0.1,1.3-0.2,1.7-0.7c0.3-0.4,0.4-1,0.3-1.5L110.2,26.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101080009832756524570000018052786015762491032_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.25,
    y1: 16.7647,
    x2: 134.25,
    y2: 66.7889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#10284B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E5FAD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101080009832756524570000018052786015762491032_)"
    },
    d: "M153.4,26.6c0-1.1-0.1-2.1-0.2-3.2 c-0.2-2.2-1.5-2.4-2-2.4s-1.8,0.3-2.1,2.5c-0.1,1.1-0.2,2.3-0.2,3.4v15c-2.6-1.8-5.9-4.1-10.1-7c-5.1-3.5-9.6-6.7-13.7-9.5 c-6.1-4.2-6.5-4.3-6.6-4.4c-0.4-0.2-0.8-0.2-1.2-0.2c-1.1-0.1-2,0.6-2.2,1.7c0,0.1,0,0.2,0,0.3v43.1c0.1,0.5,0.2,0.9,0.4,1.4 c0.3,0.8,1.2,1.2,2,1.2c1.5,0,2-0.8,2.1-1.2c0.1-0.5,0.2-0.9,0.2-1.4V47.2c2.4,1.7,5.1,3.5,8,5.6c3.6,2.5,8.4,5.7,14.1,9.6 c8.9,6,8.9,6,9.3,6c0.6,0.1,1.3-0.2,1.7-0.7c0.3-0.4,0.4-1,0.3-1.5L153.4,26.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111179621511078550690000006273000200062541463_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.5563,
    y1: 16.7647,
    x2: 176.5563,
    y2: 66.7889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#10284B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E5FAD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111179621511078550690000006273000200062541463_)"
    },
    d: "M192.9,63.4c-0.5-0.1-1.1-0.1-1.6-0.1 h-13.9V38.4h12.5c0.4,0,0.8-0.2,1.2-0.3c0.7-0.3,1.1-1,1.1-2.2c0-0.9-0.6-1.7-1.5-1.8c-0.5-0.1-1.1-0.1-1.6-0.1h-11.7v-7.8H189h0.2 c0.5-0.1,1.1-0.2,1.6-0.4c0.9-0.3,1.6-1.2,1.4-2.2c0-0.9-0.6-1.7-1.5-1.9c-0.5-0.1-1.1-0.2-1.6-0.2h-30.5v46.3h33.1 c0.5,0,1.1-0.2,1.6-0.4c0.8-0.4,1.3-1.3,1.2-2.2C194.5,64.3,193.8,63.5,192.9,63.4z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.ca5dd317fd940d92e73b1457b9ba0d08.svg";
export { ForwardRef as ReactComponent };